import { ReactNode } from 'react';

import { FREQUENCY_COLUMN_HEADING } from '~/core/shared/constants/expenses';

// The frequency select carries no visible label of its own: on screen it is
// identified by its row and its column, so its name is composed from both.
export const getFrequencyFieldLabel = (expenseLabel: ReactNode): ReactNode =>
  typeof expenseLabel === 'string'
    ? `${expenseLabel} ${FREQUENCY_COLUMN_HEADING}`
    : expenseLabel;
